<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <p>
          Thanks for signing up! You'll be receiving an email with more details momentarily.
        </p>

        <img class="pure-u-1" src="../../assets/images/cider.jpg">
        <p>
          Look forward to 6 ciders, intricate tasting notes and a <span class="italics">Cider Lifestyle™</span> Mini Magazine every month!
        </p>
        <p>
          If you have any questions, concerns, or suggestions feel free to drop us a line anytime at
          <a href="mailto:support@tavour.com">support@tavour.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'SuccessCider',
    created() {
      /* global ga fbq */
      ga('send', 'pageview', `/${store.get('subscription')}/Success`);
      fbq('track', 'CiderSubsConfirm');

      store.clear();
    },
  };
</script>

<style>
  img {
    width: 100%;
  }
  .italics{
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// SuccessCider.vue?32308a44